export const ID = '6a264720-fc94-4a9d-a04f-6a49237b4b43';

export const NAME = 'StorageMart Express Checkout (Legacy)';
